<script>
import { Bar } from "vue-chartjs";

export default {
    extends: Bar,
    props: [
        'data'
    ],
    mounted() {
        this.renderChart(
            this.data,
            { responsive: true, maintainAspectRatio: true }
        );
    }
};
</script>



// WEBPACK FOOTER //
// resources/js/admin-panel/components/admin/charts/BarChart.vue